import { createSelector, Selector } from 'reselect'

import { LegalState } from './legalTexts.reducer'

import { RootState } from '~/core/store/root.reducer'

type GetLegal = Selector<RootState, LegalState>

const getLegal: GetLegal = (state: RootState) => state.legalTexts

export const selectIsLegalLoading = createSelector(getLegal, (legal) => legal.loading)

export const selectLegalTexts = createSelector(getLegal, (legal) => legal.data)

export const selectLegalTextsError = createSelector(getLegal, (legal) => !!legal.errorCode)
